import {
  CompensationsFormFieldsDocument,
  DeleteCompensationsEmployeesCompensationsValidationDocument,
  DeleteCompensationsEmployeesCompensationsValidationMutation,
  DeleteCompensationsEmployeesCompensationsValidationMutationVariables,
  EditCompensationsFormDocument,
  EmployeePayrollRunsDocument,
  ValidationTypeFiltersDocument,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

const useDeleteCompensationsEmployeesCompensationsValidation = () => {
  const [deleteValidation, { loading }] = useMutation(
    DeleteCompensationsEmployeesCompensationsValidationDocument,
    {
      extractorFn: (data: DeleteCompensationsEmployeesCompensationsValidationMutation) =>
        data.compensationsMutations.deleteCompensationsEmployeesCompensationsValidation,
      refetchQueries: [
        EmployeePayrollRunsDocument,
        CompensationsFormFieldsDocument,
        EditCompensationsFormDocument,
        ValidationTypeFiltersDocument,
      ],
      awaitRefetchQueries: true,
    }
  )

  return {
    loading,
    deleteValidation: (
      variables: DeleteCompensationsEmployeesCompensationsValidationMutationVariables
    ) => deleteValidation({ variables }),
  }
}

export default useDeleteCompensationsEmployeesCompensationsValidation
